const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';

export const SERVICE_DISTRIBUTION_OPTIONS = IS_PRODUCTION
  ? [
      { value: 'odk', label: 'odk' },
      { value: 'amasian', label: 'amasian' },
      { value: 'odc', label: 'odc' },
    ]
  : [
      { value: 'odk-staging', label: 'odk-staging' },
      { value: 'amasian-staging', label: 'amasian-staging' },
      { value: 'odc-staging', label: 'odc-staging' },
    ];

export const STATUS_OPTIONS = [
  { value: 'published', label: 'enabled' },
  { value: 'unpublished', label: 'disabled' },
  // { value: 'draft', label: 'Draft' },
];

export const MOVIE_AGE_RATING_OPTIONS = [
  { value: 'G', label: 'G (All)' },
  { value: 'PG', label: 'PG (R12)' },
  { value: 'PG-13', label: 'PG-13 (R13)' },
  { value: 'R', label: 'R (R17)' },
  { value: 'NC-17', label: 'NC-17 (R17)' },
];
